import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';

import { HBox, VBox } from '../Box';
import { CompanySelection } from '../../modules/Companies/components/CompanySelection';
import { CompanyLabelById } from '../../modules/Companies/components/CompanyLabelById';
import { translateCountry } from '../../modules/Companies/translate-countries';

import ButtonComponent from '../../containers/App/Components/Button/Button';
import ModalComponent from '../../containers/App/Components/Modal/Modal';
import CheckboxComponent from '../../containers/App/Components/Checkbox/Checkbox';
import { makeSelectLocale } from '../../containers/LanguageProvider/selectors';
import { getPropByName } from '../../utils/props';
import env from '../../env';

const Container = styled.div`
  background-color: #fff;

  .selected {
    opacity: 1;
    padding-left: 12px;
  }

  .button {
    width: 100%;
    margin: 0;
  }
`;

const Address = styled.div`
  border: ${props => (props.isActive ? '1px solid rgb(21, 172, 121)' : '1px solid grey')};
  border-radius: 6px;
  padding: 12px;
  width: calc(50% - 10px);
  margin: 6px 0;
  font-size: 12px;
  min-height: 118px;

  @media (max-width: 768px) {
    width: 100%;
  }

  .button {
    margin: 0 -12px;
  }
  .name {
    font-size: 12px;
  }
  .address {
    margin-top: 12px;
  }
`;

const STATE = {
  select: false,
  company: null,
};
/* eslint-disable react/prefer-stateless-function */
class SearchLocationCompanyIdComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState) {
    const locationCompanyFilter = this.props.filter.properties.find(item => item.key === 'location_company_id');
    if (!locationCompanyFilter?.value?.[0] && this.state.company) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ company: null });
    }

    const locationAddressFilter = this.props.filter.properties.find(item => item.key === 'location_address_id');
    if (!locationAddressFilter?.value?.[0] && this.state.selectedAddress) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ selectedAddress: null });
    }
  }

  get locale() {
    return this.props.locale;
  }

  close() {
    this.setState({ ...STATE });
  }

  reset() {
    this.close();

    this.props.reset('location_company_id');
    this.props.reset('location_address_id');
  }

  onSelect(company) {
    this.setState({ company, active: false });
    const label = `${getPropByName(company, 'name') ?? ''} ${getPropByName(company, 'surname') ?? ''}`;

    this.props.changeValues('location_company_id', company?.id, label);
  }

  handleSetAddress = a => {
    this.setState({ selectedAddress: a });
    const label = `${a?.addressLine1 ?? ''} ${a.city ?? ''}`;
    this.props.changeValues('location_address_id', a?.id, label);
  };

  setHome() {
    this.props.reset('location_address_id');
    this.props.change({ id: 4, name: 'Thuis' });

    this.setState({ select: false });
  }

  applyFilters() {
    this.setState({ select: false });
    this.props.applyFilters();
  }

  render() {
    let current = this.props.filter.properties.find(f => f.key == 'location_company_id')?.value;
    return (
      <Container>
        <ButtonComponent style={'ButtonSoftPrimary'} onClick={this.setStateFn({ select: true })}>
          {this.lbl('vehicle.property.location_company_id')}
        </ButtonComponent>

        {this.renderModal()}
      </Container>
    );
  }

  renderModal() {
    if (!this.state.select) return;
    return (
      <ModalComponent
        size={'modal-lg'}
        onClose={this.close.bind(this)}
        title={this.lbl(`vehicle.property.location_company_id`)}
      >
        <VBox gap={12}>
          {!env.wientjes_installation && !env.autohuis_salland_installation ? (
            <ButtonComponent style={'ButtonSoftEdit'} onClick={() => this.setHome()}>
              Thuis
            </ButtonComponent>
          ) : (
            <ButtonComponent style={'ButtonSoftEdit'} onClick={() => this.setHome()}>
              Thuis
            </ButtonComponent>
          )}
          <br />
          <HBox left vCenter>
            <div style={{ width: '100%' }}>
              <ButtonComponent
                style={'ButtonSoftPrimaryFullWidth'}
                disabled={this.props.disabled}
                onClick={this.setStateFn({ active: true, company: null, selectedAddress: null })}
              >
                {this.lbl('vehicle.select_relation')}
              </ButtonComponent>
            </div>
          </HBox>
          <div className="mb-2 w-100">
            {this.state.company && !this.state.active ? (
              <CompanyLabelById company_id={this.state.company?.id} key={this.state.company?.id} fetchName />
            ) : (
              <CompanySelection onSelect={company => this.onSelect(company)} company={this.state.company} />
            )}
          </div>
          {this.state.company && !this.state.active && (
            <HBox vCenter left flexWrap flip={window.innerWidth < 768} style={{ gap: 10 }}>
              {this.state.company?.addresses?.map(address => (
                <Address
                  key={`${address?.id}`}
                  onClick={() => this.handleSetAddress(address)}
                  isActive={this.state.selectedAddress?.id === address?.id}
                >
                  <VBox left>
                    <HBox vCenter>
                      <h6 className="name">{this.lbl(`address.type.${address?.type?.name || 'other'}`)}</h6>
                      <CheckboxComponent checked={this.state.selectedAddress?.id === address?.id} />
                    </HBox>
                    <VBox className="address" left>
                      <div>{address?.addressLine1}</div>
                      <div>
                        {address?.postcode} {address?.city}
                      </div>
                      <div>{translateCountry(address.country?.name, this.locale)}</div>
                    </VBox>
                  </VBox>
                </Address>
              ))}
            </HBox>
          )}
        </VBox>
        <div className="mt-2 d-flex gap-2">
          <ButtonComponent style={'ButtonSoftEdit'} onClick={() => this.applyFilters()}>
            {this.lbl('vehicle.filter.apply')}
          </ButtonComponent>
          <ButtonComponent
            style={'ButtonSoftDelete'}
            onClick={() => this.reset()}
          >
            {this.lbl('cancel')}
          </ButtonComponent>
        </div>
      </ModalComponent>
    );
  }
}

SearchLocationCompanyIdComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
  reset: PropTypes.func.isRequired,
  applyFilters: PropTypes.func.isRequired,
  changeValues: PropTypes.func.isRequired,
  change: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    locale: makeSelectLocale(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const SearchLocationCompanyIdBase = compose(withConnect, withRouter, injectIntl)(SearchLocationCompanyIdComp);
